<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block user-listing">
            <b-card-header>
                <b-row class="mt-2">
                




    <b-col cols="12" class="mt-3 d-flex align-items-center search-field">
                        <div class="input-group mb-0">
                            <b-form-input class="form-control" type="text" :placeholder="$translate('search_user')"
                                v-model="query"></b-form-input>
                            <div class="input-group-prepend bg-transparent">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </div>
                        <slot></slot>
                        &nbsp;&nbsp;
                        <b-button
                        id="export-user-btn"
                        variant="blue-icon"
                        v-b-tooltip.hover
                        :title="$translate('export')"
                        @click="export_users()"
                        v-if="hasPermissionCreate"
                      >
                        <img src="@/assets/images/icon/export.svg" />
                      </b-button>
                    </b-col>










                </b-row>
            </b-card-header>
            <b-card-body class="button-off">
                <b-col class="page-block">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :items="users" :fields="fields" responsive>
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button id="view-user" variant="pink-button" @click="viewUser(row.value)">
                                <img src="@/assets/images/icon/view.svg" />
                                <!-- <i class="fa fa-eye" aria-hidden="true"></i> -->
                            </b-button>
                        </template>

                        <template #cell(name)="row">
                            <span class="name mb-0 text-sm">{{ row.item.firstName }}
                                {{ row.item.lastName }}</span>
                        </template>

                        <template #cell(roles)="row">
                            <b-badge variant="success" v-for="(role, index) in row.item.roles" :key="index">
                                {{ role.role.name }} </b-badge><br />
                        </template>
                        <template #cell(description)="row">
                            
                            <span class="name mb-0 text-sm" v-if="(row.item.department_name != '' && row.item.department_name != null ) ||  (row.item.division  != '' && row.item.division  != null ) || (row?.item?.customer?.name != '' && row?.item?.customer?.name != null)  ">{{ row.item.department_name }}<span v-if="row.item.department_name != '' && row.item.department_name != null">,</span>
                                {{ row.item.division }}<span v-if="row.item.division != '' && row.item.division != null ">,</span>{{row.item?.customer?.name}}</span>
                          
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="right"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'users-table',
    mixins: [popupMixins, permissionsMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            query: '',
            tableLoading: false,

        }
    },
    watch: {
        users: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$store.dispatch("users/set_user_filter",query);
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    mounted() {
        this.$store.dispatch('roles/fetch', {
            query: '',
            page: 1,
        })
        this.$store.dispatch('permissions/all')

        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.tableLoading = true
                const {
                    query,
                    pagination: { page },
                } = this
                await this.$store.dispatch('users/fetchUsers', {
                    query,
                    page,
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        viewUser(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        async export_users(){
            const {
                    query,
                    pagination: { page },
                } = this
            this.tableLoading = true
            await this.$store.dispatch('users/ExportExcel',{query : query })
            this.tableLoading = false
        }
    },

    computed: {
        fields() {
            return [{ key: 'id', label: this.$translate('actions') }, { key: 'name', label: this.$nameLabel() }, { key: 'roles', label: this.$translate('roles') }, { key: 'email', label: this.$translate('email') },
            { key: 'description', label: this.$translate('description') }
            ]
        },
        users() {
            return this.$store.state.users.users
        },
        user() {
            return this.$store.state.user
        },

        pagination() {
            return this.$store.state.users.pagination || {}
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
    },
}
</script>
<style></style>
